import { render, staticRenderFns } from "./DetailsEditGroup.vue?vue&type=template&id=5dfa3ccb&scoped=true"
import script from "./DetailsEditGroup.vue?vue&type=script&lang=js"
export * from "./DetailsEditGroup.vue?vue&type=script&lang=js"
import style0 from "./DetailsEditGroup.vue?vue&type=style&index=0&id=5dfa3ccb&prod&lang=css"
import style1 from "./DetailsEditGroup.vue?vue&type=style&index=1&id=5dfa3ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa3ccb",
  null
  
)

export default component.exports